export class BankStatement {
  id?: number;
  currentDate?: Date;
  value?: number;
  userId?: number;
}
